import { useApp } from '../context.js';
import { FLOATING_ITEMS, DEFAULT_FLOATING_EMOJI } from '../presets.js';

export default function FloatingBg() {
    const { currentProfile, floatingEmoji, showFloatingBg } = useApp();
    if (!showFloatingBg) return null;
    return (
        <div className="floating-bg">
            {FLOATING_ITEMS.map((item, i) => (
                <div
                    key={i}
                    className="floating-item"
                    style={{
                        left: item.left,
                        fontSize: `${item.size}px`,
                        animationDuration: `${item.duration}s`,
                        animationDelay: `${item.delay}s`
                    }}
                >
                    {floatingEmoji || (currentProfile === 'les' ? DEFAULT_FLOATING_EMOJI.les : DEFAULT_FLOATING_EMOJI.doug)}
                </div>
            ))}
        </div>
    );
}
